import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  Container,
  SelectBox,
  OptionsContainer,
  Option,
  Checkbox,
  CheckedIcon,
  InputContainer,
  Icon,
  DropdownIndicator,
} from './styles.js'
import Loading from '@components/loading'

import _ from 'lodash'
import colors from '@settings/styleSettings'

const MultipleSelect = ({
  options,
  loading,
  onChange,
  disabled,
  onSearch,
  onMenuScrollToBottom,
  beneficiaries,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const placeholder = `(${beneficiaries}) beneficiário${
    beneficiaries > 1 ? 's' : ''
  } selecionado${beneficiaries > 1 ? 's' : ''}`

  const [inputPlaceHolder, setInputPlaceholder] = useState(placeholder)
  const optionsContainerRef = useRef(null)
  useEffect(() => {
    if (disabled) {
      setInputPlaceholder('Todos os beneficiários selecionados')
      setIsOpen(false)
    } else {
      setInputPlaceholder(placeholder)
    }
  }, [disabled])

  const handleScroll = () => {
    const container = optionsContainerRef.current
    if (container) {
      const { scrollTop, scrollHeight, clientHeight } = container
      if (Math.round(scrollTop) + clientHeight >= scrollHeight) {
        onMenuScrollToBottom()
      }
    }
  }

  const renderOptions = (option) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Checkbox checked={option.value.isSelected}>
        {option.value.isSelected && (
          <CheckedIcon className="material-icons-outlined">check</CheckedIcon>
        )}
      </Checkbox>
      {option.label}
    </div>
  )

  const toggleSelect = () => {
    setIsOpen(!isOpen)
    !isOpen
      ? setInputPlaceholder('Digite nome ou CPF do beneficiário')
      : setInputPlaceholder(placeholder)
  }

  return (
    <Container>
      <InputContainer error={false}>
        {isOpen && (
          <Icon
            style={{ fontSize: '28px' }}
            className="material-icons-outlined"
          >
            search
          </Icon>
        )}
        <SelectBox
          disabled={disabled}
          onClick={toggleSelect}
          onChange={(e) => onSearch(e.target.value)}
          isOpen={isOpen}
          placeholder={inputPlaceHolder}
        />
        {!isOpen && (
          <DropdownIndicator>
            <span
              style={{ fontSize: '20px' }}
              className="material-symbols-outlined"
            >
              expand_more
            </span>
          </DropdownIndicator>
        )}
      </InputContainer>
      {isOpen && (
        <OptionsContainer ref={optionsContainerRef} onScroll={handleScroll}>
          {_.map(options, (option, index) => (
            <Option key={index} onClick={() => onChange(option.value.id)}>
              {renderOptions(option)}
            </Option>
          ))}
          {loading && (
            <Loading
              color={colors.strongGreen}
              style={{ display: 'flex', justifyContent: 'center' }}
              height={30}
              width={30}
            />
          )}
        </OptionsContainer>
      )}
    </Container>
  )
}

MultipleSelect.propTypes = {
  options: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onSearch: PropTypes.func,
  onMenuScrollToBottom: PropTypes.func,
  beneficiaries: PropTypes.number,
}

MultipleSelect.defaultProps = {
  loading: false,
  onChange: () => {},
  disabled: false,
  onSearch: () => {},
  onMenuScrollToBottom: () => {},
  beneficiaries: 0,
}

export default MultipleSelect
